import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import { fetchPageData } from "../endpoint/pageApi";
import InvitingPartners from "../components/InvitingPartners/InvitingPartners";
import JoinWaitListSection from "../components/JoinWaitlistSection/JoinWaitListSection";
import { baseUrl } from "../utils/base_url";
import PictureLayout2 from "../components/PictureLayout/PictureLayout2";
import HowWeHelp from "../components/HowWeHelp/HowWeHelp";
import IndustryStandard from "../components/IndustryStandard/IndustryStandard";
import boximg from "../assets/image/tempvideoboxforabout.png";
import pointerIcon from "../assets/image/pointer.png";
import doubleQuotesIcon from "../assets/image/doublequotes.png";
import ShadowCard from "../components/ShadowCard/ShadowCard";
import AboutSecond from "../components/AboutSecond/AboutSecond";
// import { _1200px, _1400px, _1700px, _576px } from "../utils/mediaBreakpoints";
import { useMediaQuery } from "react-responsive";
import PractitionersCarousel from "../components/Carousel/PractitionersCarousel";
import { Link, useNavigate } from "react-router-dom";
import img1 from "../assets/image/Ellipse_50.png";
import img2 from "../assets/image/Ellipse_55.png";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from ".././utils/mediaBreakpoints";
import teamFrame from "../assets/image/TeamFrame.png";
import testImage from "../assets/image/testImage.jpeg";

const AboutUsCard = ({ data }) => {
  return (
    <>
      <div
        className="d-flex flex-column gap-4 rounded-4 shadow-sm p-4 h-100"
        style={{
          background:
            "linear-gradient(205.93deg, #101639 37.11%, #020611 99.27%)",
        }}
      >
        <h1 className="fs-2 fw-bold text-white">{data?.heading}</h1>
        <p className="text-white fs-5">{data?.description}</p>
      </div>
    </>
  );
};

const MemberView = ({ data, isMobile }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const navigate = useNavigate();
  // const handleClick = (name) => {
  //   const trimmedName = name?.slice(0, 3);
  //   localStorage.setItem("clickedName", trimmedName);
  //   navigate("/team", { state: { fromAbout: true } });
  // };
  // console.log("handleClick", handleClick);

  return (
    <>
      <Link to={data?.Link}>
        <div className="cursor-pointer d-flex flex-column flex-lg-row align-items-center justify-content-center py-2 ps-xl-5 ms-xl-5">
          {/* <img
          src={`${baseUrl}${data?.image?.url}`}
          alt=""
          className="aboforimg"
          style={{
            width: isMobile ? "50%" : "189.77px",
            height: isMobile ? "" : "195.23px",
          }}
        /> */}
          <div
            className="position-relative"
            // key={idx}
            // onClick={() => setSelectedMemberData(data)}
            style={{
              width: _1400 ? "120px" : _1600 ? "125px" : "135px",
              height: _1400 ? "120px" : _1600 ? "125px" : "135px",
              flex: "0 0 auto",
            }}
          >
            {/* Member Image */}
            <img
              src={`${baseUrl}${data?.image?.url}`}
              // src={testImage}
              alt="member"
              className="position-absolute"
              style={{
                top: "45%",
                left: "46%",
                transform: "translate(-50%, -50%)",
                width: _1400 ? "106px" : _1600 ? "125px" : "135px",
                height: _1400 ? "106px" : _1600 ? "125px" : "135px",
                objectFit: "cover",
                borderRadius: "100%",
                zIndex: 1,
              }}
            />

            {/* Frame */}
            <img
              src={teamFrame}
              alt="frame"
              className="position-absolute"
              style={{
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: _1400 ? "120px" : _1600 ? "137px" : "148px",
                zIndex: 2,
              }}
            />
          </div>
          {/* <div className="profile-circle">
          <img className="img_1" src={`${baseUrl}${data?.image?.url}`} />
          <img className="img_2" src={img1} />
          <img className="img_3" src={img2} />
        </div> */}
          <div
            className="d-flex flex-column gap-2 ps-lg-4 w-75"
            style={{ lineHeight: "2.2rem" }}
          >
            <div className="d-flex flex-column">
              <span
                className={`text-white fw800 aboforname ${
                  isMobile ? "fs20" : "fs30"
                } `}
              >
                {data?.name}
              </span>
              <div
                className="mx-auto mx-lg-0 aboforline"
                style={{
                  backgroundColor: "#0033A0",
                  width: isMobile ? "40%" : "102.3px",
                  height: "3.9px",
                }}
              ></div>
            </div>
            <span className="text-white fw800 fs18 abofordes lh-1">
              {data?.designation}
            </span>
          </div>
        </div>
      </Link>
    </>
  );
};

const MainAboutsUsPage = ({ data, isMobile }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div
        className="container-fluid p-0 m-0"
        style={{
          // background:
          //   " linear-gradient(67deg, rgba(16,22,57,1) 37%, rgba(2,6,17,1) 62%)",
          background: "#090D24",
        }}
      >
        {/* <div className="container px-0 contwidth"> */}
        <div className="row justify-content-center py-md-5 py-3 gy-5 gap-4">
          {/* <div className="col-md-6 p-md-5">
            <div className="d-flex flex-column gap-5 ">
              <h1 className="text-white display-3 fw-bold">
                {data?.team_vision_card?.member[0]?.name}
              </h1>

              <p className="fs-5 text-white">
                {data?.team_vision_card?.member[0]?.description}
              </p>
            </div>
          </div>
          <div className="col-md-6 p-5 h-100">
            <PictureLayout2
              img={`${baseUrl}${data?.team_vision_card?.member[0]?.image?.url}`}
            />
          </div> */}

          <div className="col-12">
            <div className="container px-0 contwidth">
              <div className="d-flex flex-column align-items-center mb-4 pb-5 pt-2 w-100">
                {data?.about_header?.heading && (
                  <p
                    className={`text-white ${
                      isMobile ? "fs35 px-4" : "fs90 abotop"
                    } fw900 text-center m-0 p-0 w-100`}
                    style={{
                      lineHeight: isMobile ? "2.7rem" : "5.8rem",
                      wordSpacing: isMobile ? "-3px" : "-5px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: data.about_header.heading?.replace(
                        "tools.",
                        "tools.<br/>"
                      ),
                    }}
                  />
                )}
                {data?.about_header?.sub_heading && (
                  <p
                    className={`text-white ${
                      isMobile ? "fs18 px-4" : "fs40 abotopsub"
                    } fw-semibold text-center m-0 p-0`}
                    style={{ lineHeight: isMobile ? "2rem" : "2.5rem" }}
                    dangerouslySetInnerHTML={{
                      __html: data.about_header.sub_heading?.replace(
                        "powered",
                        "powered<br/>"
                      ),
                    }}
                  />
                )}
              </div>
              <PractitionersCarousel data={data} />

              {/* <img
                src={boximg}
                alt=""
                className={`${isMobile ? "px-5" : ""} px-md-4 px-lg-0`}
                style={{ width: "100%" }}
              /> */}
            </div>
          </div>

          {/* <div className="col-12"> */}
          {/* <div className="row">
                <div className="col-lg-5 d-flex justify-content-center mb-5 mb-lg-0">
                  <img
                    src={`${baseUrl}${data?.about_ask_fides?.image?.url}`}
                    alt=""
                    className="abosecimg"
                    style={{
                      width: isMobile ? "90%" : "539px",
                      height: isMobile ? "" : "649px",
                    }}
                  />
                </div>
                <div className="col-lg-7">
                  <div className="d-flex flex-column gap-4 gap-xxl-5 px-0 ps-xl-4">
                    <span
                      className={`text-white fw300 abosecsup ${
                        isMobile ? "fs20 px-4" : "fs30"
                      } `}
                    >
                      {data?.about_ask_fides?.super_heading}
                    </span>

                    {data?.about_ask_fides?.description &&
                      (() => {
                        const phrase = "It’s a shift";
                        const [before, after] =
                          data.about_ask_fides.description.split(phrase);
                        return (
                          <p
                            className={`text-white abosecdes ${
                              isMobile ? "fs30 px-4" : "fs60"
                            }  fw800`}
                            style={{ lineHeight: isMobile ? "2rem" : "4rem" }}
                          >
                            {before}
                            <span style={{ color: "#459EFF" }}>{phrase}</span>
                            {after}
                          </p>
                        );
                      })()}

                    <div className="d-flex flex-column gap-3">
                      {data?.about_ask_fides?.tool_pointers?.map(
                        (pointer, idx) => (
                          <div
                            key={idx}
                            className={`d-flex align-items-center ${
                              isMobile ? "gap-2 px-4" : "gap-4"
                            } me-lg-5 pe-lg-5`}
                          >
                            <img src={pointerIcon} alt="" />
                            <span
                              className={`text-white ${
                                isMobile ? "fs18" : "fs24"
                              } fw400 lh-sm abosecpoin`}
                            >
                              {pointer?.description}
                            </span>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div> */}
          <div className="col-12 px-2 px-md-5 px-lg-2">
            <AboutSecond
              isMobile={isMobile}
              imgurl={data?.about_ask_fides?.image?.url}
              heading={data?.about_ask_fides?.super_heading}
              description={data?.about_ask_fides?.description}
              pointers={data?.about_ask_fides?.tool_pointers}
            />
          </div>
          {/* </div> */}

          <div className="col-12 px-2 px-md-5 px-lg-2">
            <div className="container px-0 contwidth">
              <div className="d-flex align-items-center justify-content-start px-0 pt-5 mt-5 pb-5 ">
                <span
                  className={`text-white fw800 abothrhead ${
                    isMobile ? "fs25" : "fs40"
                  }`}
                >
                  {data?.founder_message?.heading}
                </span>
              </div>

              <div className="row">
                <div className="col-lg-4">
                  <div className="d-flex flex-column gap-2 align-items-center">
                    <div className="pt-5">
                      {/* <img
                        src={`${baseUrl}${data?.founder_message?.founder_image?.url}`}
                        alt=""
                        className="abothrimg"
                        style={{
                          width: isMobile ? "100%" : "318px",
                          height: isMobile ? "" : "327.15px",
                        }}
                      /> */}
                      <div
                        className="position-relative"
                        style={{
                          width: _1400 ? "220px" : _1600 ? "240px" : "260px",
                          height: _1400 ? "220px" : _1600 ? "240px" : "260px",
                          flex: "0 0 auto",
                        }}
                      >
                        {/* Member Image */}
                        <img
                          src={`${baseUrl}${data?.founder_message?.founder_image?.url}`}
                          // src={testImage}
                          alt="member"
                          className="position-absolute"
                          style={{
                            top: "44.5%",
                            left: "46%",
                            transform: "translate(-50%, -50%)",
                            width: _1400 ? "180px" : _1600 ? "220px" : "230px",
                            height: _1400 ? "180px" : _1600 ? "220px" : "230px",
                            objectFit: "cover",
                            borderRadius: "100%",
                            zIndex: 1,
                          }}
                        />

                        {/* Frame */}
                        <img
                          src={teamFrame}
                          alt="frame"
                          className="position-absolute"
                          style={{
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: _1400 ? "200px" : _1600 ? "250px" : "260px",
                            zIndex: 2,
                          }}
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-column text-white fw800 w-100 align-items-center">
                      <span
                        className={`${isMobile ? "fs18" : "fs30"} abothrfname`}
                      >
                        {data?.founder_message?.founder_name}
                      </span>
                      <div className="d-flex flex-column flex-lg-row align-items-center gap-3 align-self-center align-self-lg-start ps-lg-4">
                        <div
                          className="abothrline"
                          style={{
                            backgroundColor: "#0033A0",
                            width: "131px",
                            height: "5px",
                          }}
                        ></div>
                        <span
                          className={`${
                            isMobile ? "fs14" : "fs18"
                          } abothrfpos text-center text-start`}
                        >
                          {data?.founder_message?.founder_position}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-8">
                  <div
                    className={`d-flex flex-column gap-4 aboot-founder-message-section ${
                      isMobile ? "px-4" : ""
                    } ps-lg-1`}
                  >
                    <div className="position-relative">
                      <div className="position-absolute">
                        <img
                          src={doubleQuotesIcon}
                          alt=""
                          className="abothrquotes"
                          style={{
                            width: isMobile ? "100%" : "38.61px",
                            height: isMobile ? "" : "30.88px",
                          }}
                        />
                      </div>
                      <div
                        className={`text-white abothrfmess ${
                          isMobile ? "fs20" : "fs26"
                        }  fw300 px-4 px-md-5  py-4`}
                        style={{
                          lineHeight: isMobile ? "1.5rem" : "2rem",
                          textAlign: "justify",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: data?.founder_message?.message.replace(
                            /\n/g,
                            "<br />"
                          ),
                        }}
                      />
                      <div
                        className="position-absolute end-0 "
                        style={{ bottom: "2%" }}
                      >
                        <img
                          src={doubleQuotesIcon}
                          alt=""
                          className="abothrquotes"
                          style={{
                            transform: "scaleX(-1)",
                            width: isMobile ? "100%" : "38.61px",
                            height: isMobile ? "" : "30.88px",
                          }}
                        />
                      </div>
                    </div>
                    <div className="mt-3 me-lg-auto ps-lg-5">
                      <div
                        className={`fw800 abothrbuzz ${
                          isMobile ? "fs25" : "fs60"
                        } text-center text-white`}
                        style={{ lineHeight: isMobile ? "2rem" : "4rem" }}
                        dangerouslySetInnerHTML={{
                          __html: data?.founder_message?.buzz_words
                            ?.split("\n")
                            .map((line, index) => {
                              const color = index === 0 ? "#FFFFFF" : "#459EFF";
                              const cleanLine = line.replace(/^#\s*/, "");
                              return `<span style="color: ${color}">${cleanLine}</span>`;
                            })
                            .join("<br />"),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 px-2 px-md-5 px-lg-2">
            <div className="container px-0 contwidth">
              <div className="d-flex flex-column justify-content-start py-5 my-5">
                <span
                  className={`text-white aboforsup ${
                    isMobile ? "fs20" : "fs30"
                  }  fw300`}
                >
                  {data?.executive_leadership?.super_heading}
                </span>
                <span
                  className={`text-white fw800 aboforhead`}
                  style={{
                    fontSize: _576
                      ? "28px"
                      : _1200
                      ? "35px"
                      : _1400
                      ? "40px"
                      : _1700
                      ? "45px"
                      : "60px",
                  }}
                >
                  {data?.executive_leadership?.heading}
                </span>
              </div>

              <div className="row gx-5 gy-3 pt-4 pb-5">
                {data?.executive_leadership?.member?.map((item, idx) => (
                  <div
                    key={idx}
                    className="col-12 col-md-6 text-center text-lg-start mb-3 ps-lg-5 pe-lg-0"
                  >
                    <MemberView data={item} isMobile={isMobile} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}

        {/* <div className="row justify-content-center p-md-5 gap-2 h-100 ">
          {data?.about_cards?.about?.map((data, idx) => (
            <div key={idx} className="col-lg-3  ">
              <AboutUsCard data={data} />
            </div>
          ))}
        </div> */}
      </div>
    </>
  );
};

const AboutUs = ({ isMobile }) => {
  const [pageData, setPageData] = useState({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchPageData("pages?filters[slug][$eq]=about-us", setPageData, setLoader);
  }, []);
  return (
    <>
      <MainLayout loader={loader}>
        <div className="container-fluid  p-0 overflow-x-hidden">
          <MainAboutsUsPage data={pageData} isMobile={isMobile} />
          {/* {pageData?.industry_standard && (
            <IndustryStandard data={pageData?.industry_standard} />
          )} */}
          {/* {pageData?.collaborator && (
            <InvitingPartners
              data={pageData?.collaborator}
              try_ask_fide={pageData?.try_ask_fide}
            />
          )} */}
          {/* {pageData?.how_we_help && <HowWeHelp data={pageData?.how_we_help} />} */}
          {/* <JoinWaitListSection data={pageData?.try_ask_fide} /> */}
        </div>
      </MainLayout>
    </>
  );
};

export default AboutUs;

{
  /* <div className="d-flex flex-column flex-lg-row align-items-lg-start align-items-center mt-5 gap-5"> */
}
{
  /* <div className="d-flex flex-column gap-2 aboot-founder-img-section align-items-center">
                  <div className="">
                    <img
                      src={`${baseUrl}${data?.founder_message?.founder_image?.url}`}
                      alt=""
                      style={{
                        width: isMobile ? "100%" : "318px",
                        height: isMobile ? "" : "327.15px",
                      }}
                      className="ms-lg-5"
                    />
                  </div>
                  <div className="d-flex flex-column text-white fw800 w-100 align-items-center">
                    <span className={`${isMobile ? "fs18" : "fs30"} ms-lg-4`}>
                      {data?.founder_message?.founder_name}
                    </span>
                    <div className="d-flex flex-column flex-md-row align-items-center gap-3 align-self-start w-100 ms-lg-3">
                      <div
                        className={`${isMobile ? "w-100" : "w-25"}`}
                        style={{
                          backgroundColor: "#0033A0",
                          width: "131px",
                          height: "5px",
                        }}
                      ></div>
                      <span
                        className={`${
                          isMobile ? "fs14 text-center" : "fs18"
                        } w-75`}
                      >
                        {data?.founder_message?.founder_position}
                      </span>
                    </div>
                  </div>
                  
                </div> */
}

/* <div
                  className={`d-flex flex-column gap-4 aboot-founder-message-section ${
                    isMobile ? "px-4" : ""
                  } ps-lg-1`}
                >
                  <div className="position-relative ">
                    <div className="position-absolute">
                      <img
                        src={doubleQuotesIcon}
                        alt=""
                        style={{
                          width: isMobile ? "100%" : "38.61px",
                          height: isMobile ? "" : "30.88px",
                        }}
                      />
                    </div>
                    <div
                      className={`text-white ${
                        isMobile ? "fs20" : "fs26"
                      }  fw300 px-5 py-4`}
                      style={{
                        lineHeight: isMobile ? "1.5rem" : "2rem",
                        textAlign: "justify",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: data?.founder_message?.message.replace(
                          /\n/g,
                          "<br />"
                        ),
                      }}
                    />
                    <div
                      className="position-absolute end-0 "
                      style={{ bottom: "5%" }}
                    >
                      <img
                        src={doubleQuotesIcon}
                        alt=""
                        style={{
                          transform: "scaleX(-1)",
                          width: isMobile ? "100%" : "38.61px",
                          height: isMobile ? "" : "30.88px",
                        }}
                      />
                    </div>
                  </div>
                  <div className=" mt-3 me-xxl-auto ps-xxl-5">
                    <div
                      className={`fw800 ${
                        isMobile ? "fs25" : "fs55"
                      } text-center text-white`}
                      style={{ lineHeight: isMobile ? "2rem" : "4rem" }}
                      dangerouslySetInnerHTML={{
                        __html: data?.founder_message?.buzz_words
                          ?.split("\n")
                          .map((line, index) => {
                            const color = index === 0 ? "#FFFFFF" : "#459EFF";
                            const cleanLine = line.replace(/^#\s*/
//               return `<span style="color: ${color}">${cleanLine}</span>`;
//             })
//             .join("<br />"),
//         }}
//       />
//     </div>
//   </div> */}
// </div>
